declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, MaterialConsumptionEntries2Controller, MaterialConsumptionEntriesRequest, AdmissionsListController, AdmissionsListRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
//import { NgbAddNewPatient } from './modal/addnewpatient.modal';
import { NgbCameraUploadModal } from '../profile/patientprofileview/personaldetailview/modal/cameraupload.modal';
import { NgbAddNewPatient } from '../provider/dashboard/modal/addnewpatient.modal';
import { NgbSearchPatientModal } from '../follow up/counsellingregistry/modal/searchpatient.modal';
import { ConsumptionEntrypipe } from '../../../pipes/actors/actorIdentity.pipes';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';





@Component({
  selector: 'admissions',
  templateUrl: './admissions.component.html',
  styleUrls: [
    './admissions.component.scss']
  , animations: [routerTransition()]
})

export class AdmissionsComponent implements OnInit {


  OnGoBack() {
    //alert("I cam bak");
    this.ShowList = true;
  }
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }

  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowRegister: boolean = true;
  public Showrow: boolean = true;
  public ShowPatientDetails: boolean = false;
  SelectedFromDate: NgbDateStruct;
  SelectedToDate: NgbDateStruct;
  TodayDate = new Date();
  public isRequesting: boolean = false;
  public searchValue: string;
  public searchText: any;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;

  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;


  CurrentAdmissionsListController: AdmissionsListController[];
  CurrentAdmissionsListRequest: AdmissionsListRequest;
  LoadAdmissions() {
    this.CurrentAdmissionsListRequest = new AdmissionsListRequest();
    this.CurrentAdmissionsListRequest.ConditionalOperator = 10;
    this.CurrentAdmissionsListRequest.AdmissionCode = 0;
    this.CurrentAdmissionsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentAdmissionsListRequest.SearchText = "";
    this.CurrentAdmissionsListRequest.FromDate = new Date();
    this.CurrentAdmissionsListRequest.ToDate = new Date();
    this.CurrentAdmissionsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetAdmissionsListController();
  }
  RefreshPatients(st: string) {
    this.CurrentAdmissionsListRequest = new AdmissionsListRequest();
    this.CurrentAdmissionsListRequest.ConditionalOperator = 30;
    this.CurrentAdmissionsListRequest.AdmissionCode = 0;
    this.CurrentAdmissionsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentAdmissionsListRequest.SearchText = st;
    this.CurrentAdmissionsListRequest.FromDate = new Date();
    this.CurrentAdmissionsListRequest.ToDate = new Date();
    this.CurrentAdmissionsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetAdmissionsListController();
  }
  _GetAdmissionsListController() {
    this.StartRefreshing();


    this.actorservice.GetAdmissionsListController(this.CurrentAdmissionsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentAdmissionsListController = null;
          this.CurrentAdmissionsListController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  _GetAdmissionsListControllerbydate() {
    this.StartRefreshing();
    //alert(this.CurrentCounsellingActivitiesByTimeRequest.FromDate);
    if (this.CurrentAdmissionsListRequest.FromDate == null) {
      return;

    }
    else {

      this.actorservice.GetAdmissionsListController(this.CurrentAdmissionsListRequest)
        .subscribe((result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {

            this.CurrentAdmissionsListController = null;
            this.CurrentAdmissionsListController = this.ApiResData.Result;
            //alert(this.ApiResData.Result);
            //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
            //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
            //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
            this.stopRefreshing();

          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {

              alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            }
            else {
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            }
          }

        },


          (error) => {

            if (error == "401 - Unauthorized") {
              alertFunctions.AlertParamEr(error);
              this.stopRefreshing();



            }
            else {
              alertFunctions.AlertParamEr(error);
              this.stopRefreshing();
            }
          }


        );
    }
  }
  GetAdmissionsListController() {
    this.StartRefreshing();

    this.actorservice.GetAdmissionsListController(this.CurrentAdmissionsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //this.CurrentAdmissionsListController = this.ApiResData.Result;
          this.RefreshPatientsByDate();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  dataChanged(newobj) {

    this.RefreshPatientsByDate();
  }
  RefreshPatientsByDate() {


    this.CurrentAdmissionsListRequest = new AdmissionsListRequest();
    this.CurrentAdmissionsListRequest.AdmissionCode = 0;
    this.CurrentAdmissionsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentAdmissionsListRequest.ConditionalOperator = 10;
    this.CurrentAdmissionsListRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentAdmissionsListRequest.ToDate = new Date();
    this.CurrentAdmissionsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetAdmissionsListControllerbydate();

  }

  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    public printService: PrintService,
    private route: ActivatedRoute,
    private filter: ConsumptionEntrypipe, private loginservice: LoginService, private parserFormatter: NgbDateParserFormatter, ) { }

  ngOnInit() {

    this.CurrentActorDashBoardProfileSummaryInfoRequest = new ActorDashBoardProfileSummaryInfoRequest();
    this.CurrentDashBoardProfileSummaryController = new DashBoardProfileSummaryController();
    this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 2, day: this.TodayDate.getDate() };
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.isNew = true;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDashBoardProfileSummaryController();
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.SelectedAdmission.FormattedCode;
    this.LoadAdmissions();
    //this.GetPatientInfoByFormattedCodeController();

  }



  ShowList: boolean = true;

  GetDashBoardProfileSummaryController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.hcpservice.GetDashBoardProfileSummaryController(this.CurrentActorDashBoardProfileSummaryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('GetActorProfileController');
          this.CurrentDashBoardProfileSummaryController = this.ApiResData.Result[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }


  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }


  CancelNewOperation() {

    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }

  SelectedAdmission: AdmissionsListController;
  Open(objCategory: any) {
    var admission: AdmissionsListController = objCategory;
    if (admission != null) {
      this.SelectedAdmission = admission;
    }
    else {
      this.SelectedAdmission = null;
    }
  }
  //SelectedAdmissionDetailsController: PatientInfoByFormattedCodeController;
  //SelectedAdmissionDetailsRequest: PatientInfoByFormattedCodeRequest;
  //LoadPatientdetails() {


  //  this.SelectedAdmissionDetailsRequest = new PatientInfoByFormattedCodeRequest();

  //  this.SelectedAdmissionDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.SelectedAdmissionDetailsRequest.FormattedCode = this.SelectedAdmission.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  //  this.GetPatientInfoByFormattedCodeController();
  //}
  criteriaChange(value: string) {
    this.CurrentAdmissionsListRequest.FromDate = null;
    this.RefreshPatients(value);
  }

  DecrementDate(Value: any) {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    //console.log('this.SelectedFromDate' + this.SelectedFromDate.month + "M" + this.SelectedFromDate.day)
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;
    //console.log('this.d' +  '-' + 'year:'+ d.getFullYear()+' month:'+ d.getMonth()+' day:'+ d.getDate())
    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };
    //console.log('this.d1' + '-' + 'year:' + d.getFullYear() + ' month:' + d.getMonth()+1 + ' day:' + d.getDate())
    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    //console.log('this.SelectedFromDate1' + this.SelectedFromDate.month + "M" + this.SelectedFromDate.day)
    this.RefreshPatientsByDate();
    //ind++;
  }
  IncrementDate(Value: any) {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this.RefreshPatientsByDate();
    //ind++;
  }

  OpenBill() {
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.result.then((val: string) => {

      this.router.navigate(['healins/newadmission', { FormattedCodedata: val, Code: 0 }]);

      // modalRef.componentInstance.FormattedCode = val;
      //modalRef.componentInstance.PatientName = val;
      //modalRef.componentInstance.PatientRegistrationNumber = val;
      //modalRef.result.then(x => { this.GetTreatmentCyclesController() })
    });
  }
  edit(admParam: any) {
    var admission: AdmissionsListController = admParam;
    //alert(admission.AdmissionNo);
    if (admission != null) {
      this.SelectedAdmission = admission;
      this.router.navigate(['healins/editadmission', {
        //SelectedAdmissionString: JSON.stringify(this.SelectedAdmission)
        //,
        AdmissionCodedata: this.SelectedAdmission.AdmissionCode,
        FormattedCodedata: this.SelectedAdmission.PatientFormattedCode,
        FacilityCodedata: this.SelectedAdmission.FacilityCode
      }]);
    }
    else {
      this.SelectedAdmission = null;
    }
  }
  capture(l: PatientInfoByFormattedCodeController) {
    const modalRef = this.modalService.open(NgbCameraUploadModal,
      {
        centered: true,


      })
    modalRef.componentInstance.ActorCode = l.ActorCode;
    modalRef.componentInstance.Photo = l.Photo;
  }

  Consumptionreceipt(l: MaterialConsumptionEntries2Controller) {
    this.router.navigate(['healins/Consumptionreceipt2', { FormattedCodedata: l.PatientFormattedCode, Code: l.EntryCode, ConsumptionGroupCode: l.ConsumptionGroupCode, ConsumptionGroupName: l.ConsumptionGroupName, StoreCode: l.StoreLocation, StoreName: l.StoreLocationName }]);
  }
  printconsumption() {
    this.printService.printDocument("consumptionPV",
      {
        SelectedFromDate: this.SelectedFromDate, SelectedToDate: this.SelectedToDate, Day: this.SelectedFromDate.day, year: this.SelectedFromDate.year, month: this.SelectedFromDate.month
      }
    );
  }
  ClearInput() {
    this.searchValue = '';
    // this.searchValue = null;
    //var searchtext = '';
    this.RefreshPatients(this.searchValue);
  }
}
